import { render } from "./Actor.vue?vue&type=template&id=090b5390"
import script from "./Actor.vue?vue&type=script&lang=js"
export * from "./Actor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bits008/Project/web/btv-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__